// extracted by mini-css-extract-plugin
export default {"root":"CP6ZbrOdPoV7SkCthosz"};